/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import type DmpRetrievalContext from "parog-web/contexts/dmp-retrieval-context";

interface Args {
  context: DmpRetrievalContext;
}
export default class DmpAccessFormSetSecretConnectionComponent extends Component<Args> {
  @tracked secretConnection = false;

  @action
  onSubmit(event: Event): void {
    event.preventDefault();
    this.args.context.secretConnection = this.secretConnection;
    this.args.context.transitionTo();
  }
}
